import { render, staticRenderFns } from "./dividendpayouts.vue?vue&type=template&id=1d15ca54"
import script from "./dividendpayouts.vue?vue&type=script&lang=js"
export * from "./dividendpayouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports